import s from './Status.module.scss'

interface Props {
  label: string
  color: string
  statusClassName?: string
  dotClassName?: string
  labelClassName?: string
}

export const Status = ({ label, color, statusClassName, dotClassName, labelClassName }: Props) => {
  return (
    <div className={`${s.statusWrapper} ${statusClassName}`}>
      <div className={`${s.coloredDot} ${dotClassName}`} style={{ backgroundColor: color }} />
      <div className={`${s.label} ${labelClassName}`}>{label}</div>
    </div>
  )
}
